'use strict';

/**
 * Show/hide sidebar
 * @param {*} $context - jquery element
 * @param {Boolean} open - true if must open, false if must close sidebar
 */
var toggleSidebarVisibility = function ($context, open) {
    let $body = $('body');
    if (open) {
        if ($context.hasClass('with-active-display')) {
            $context.css({
                display: 'block',
            });
            $body.addClass('modal-open');
            setTimeout(() => $context.addClass('active'), 10);
        }
        return;
    }
    $context.removeClass('active');
    $body.removeClass('modal-open');
    setTimeout(
        () =>
            $context.css({
                display: 'none',
            }),
        400
    );
};

module.exports = {
    /**
     * init listeners for sidebar layer component
     */
    initListeners: function initListeners() {
        let $sidebars = $('.sidebar-layer');

        $sidebars.each(function processElement() {
            let $this = $(this);

            if ($this.hasClass('with-active-display')) {
                $this.on(
                    'click',
                    '.close-button, .overlay',
                    function closeSidebar() {
                        toggleSidebarVisibility($this, false);
                    }
                );
            }
        });

        $('body')
            .on('sidebar-layer:close', function closeSidebar(e, data) {
                toggleSidebarVisibility(data.target, false);
            })
            .on('click', '.js-toggle-sidebar', function handleClick() {
                let target = $(this).attr('data-toggle');
                let $targetElements = $(target);

                if ($targetElements.length) {
                    $targetElements.each(function processElement() {
                        let $this = $(this);
                        toggleSidebarVisibility($this, true);
                    });
                }
            });
    },
};
